<template>
    <div class="draft-body">
        <div class="container">
            <div class="draft-title">
                <div class="title-label">
                    {{ '草稿箱(' + total + ')'}}
                </div>
            </div>
            <div class="draft-list">
                <div
                    class="draft-item"
                    v-for="(item, index) in articleDraftList"
                    :key="'draftItem' + index"
                >
                    <div class="item-title">{{ item.title }}</div>
                    <div class="item-content" v-html="item.descContent"></div>
                    <div class="item-times">
                        <div>{{ item.updateTime || item.createTime}} 更新 </div>
                        <div>
                            <el-button type="text" class="publish-btn" @click.stop="editArticleDraft(item)">
                                <i class="el-icon-check"></i>
                                编辑发布
                            </el-button>
                            <el-button type="text" class="delete-btn" @click.stop="delArticleDraft(item)">
                                <i class="el-icon-delete"></i>
                                删除
                            </el-button>
                        </div>
                    </div>
                </div>
                <el-empty v-if="!loading && articleDraftList.length === 0" style="height: 590px;"  description="暂无数据" />
            </div>
            
            <!-- 分页组件 -->
            <div class="pagination-wrapper" v-if="articleDraftList.length > 0">
                <el-pagination
                    class="pagination-container"
                    :current-page="pageInfo.pageNum"
                    :page-size="pageInfo.pageSize"
                    :total="total"
                    layout="prev, pager, next"
                    @current-change="handlePageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {getArtileDraftList, deleteArticleDraft} from '@/api'
export default {
    data() {
        return {
            total: 0,
            articleDraftList: [],
            loading: true,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            keyword: ''
        }
    },
    methods: {
        handleSearch(data) {
            this.keyword = data.keyword;
            this.pageInfo.pageNum = 1;
            this.loading = true;
            this.articleDraftList = [];
            this.getArticleDraftList();
        },
        handleInput(value){
            this.keyword = value;
        },
        // 获取文章草稿列表
        getArticleDraftList() {
            getArtileDraftList({
                userId: this.$store.getters['user/getState'].userId,
                searchValue: this.keyword.trim(),
                pageNum: this.pageInfo.pageNum,
                pageSize: this.pageInfo.pageSize,
            }).then((res) => {
                this.articleDraftList = res.rows;
                this.total = res.total;
                this.loading = false;
            })
        },

        handlePageChange(newPage) {
            this.pageInfo.pageNum = newPage;
            this.getArticleDraftList();
        },

        // 删除草稿
        delArticleDraft(item) {
            this.$confirm('是否确定删除该草稿?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteArticleDraft(item.draftId)
                    .then(res => {
                        if(res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                            this.getArticleDraftList()
                        }
                    })
                    .catch()
            }).catch(() => {

            })
        },
        // 编辑草稿
        editArticleDraft(item, hash) {
            this.$router.push({
                name: 'CommunityPublishDraftPage',
                params: {
                    id: item.draftId
                },
                query: {
                    hash: hash
                }
            })
        }
    },
    mounted() {
        this.getArticleDraftList()
        this.$eventBus.$on('search', this.handleSearch);
        this.$eventBus.$on('input', this.handleInput);
    },
    destroyed() {
        this.$eventBus.$off('search');
        this.$eventBus.$off('input');
    }
}
</script>

<style lang="scss" scoped>
.draft-body {
    max-width: 1200px;
    padding: 20px;
    margin: 0 auto;
    box-sizing: border-box;
    width: 100%;
    .container {
        background-color: #FFFFFF;
        padding: 20px;
        border-radius: 8px;
        .draft-title {
            width: 100%;
            height: 50px;
            border-bottom: 1px #e3e3e3 solid;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title-label {
                font-size: 16px;
                color: $color-primary;
            }
        }
        .draft-list {
            width: 100%;
            height: calc(100% - 55px);
            .draft-item {
                width: 100%;
                padding: 12px 20px;
                border-bottom: 1px #e3e3e3 solid;
                &:last-child {
                    border-bottom: 0;
                }
                .item-title {
                    width: 100%;
                    font-size: 15px;
                    font-weight: bold;
                    color: #1a1a1a;
                }
                .item-content {
                    width: 100%;
                    margin: 8px 0;
                    font-size: 13px;
                    text-indent: 26px;
                    color: #333333;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    :deep(img) {
                        display: none !important;
                    }
                }
                .item-times {
                    width: 100%;
                    color: #333333;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .publish-btn {
                        padding: 0;
                        font-size: 12px;
                        margin-right: 10px;
                        color: $font-color-fourth;
                        &:hover {
                            color: $color-primary;
                        }
                        i {
                            margin-right: 4px;
                        }
                    }
                    .delete-btn {
                        padding: 0;
                        font-size: 12px;
                        color: #f56c6c;

                        &:hover {
                            color: #f78989;
                        }

                        i {
                            margin-right: 4px;
                        }
                    }
                }
            }
        }
        .pagination-wrapper {
            margin-top: 20px;
        }
    }
    :deep(.pagination-container) {
        padding-top: 10px;
        text-align: center;

        .el-pager li {
            &:not(.disabled).active {
                background-color: $color-primary;
                color: #fff;
                padding: 0 8px;
                border-radius: 4px;
            }

            &:hover {
                color: $color-primary;
            }
        }

        .btn-prev,
        .btn-next {
            &:hover {
                color: $color-primary;
            }
        }

        button:disabled {
            background-color: #fff;
        }
    }
}
</style>